import { render, staticRenderFns } from "./MarketSubSectorEdit.vue?vue&type=template&id=1854b94e&scoped=true"
import script from "./MarketSubSectorEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketSubSectorEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854b94e",
  null
  
)

export default component.exports